<template>
    <v-container>

        <v-row align="center" no-gutters>
            <v-col>
                Zeitpunkt:
                <v-btn :color="btnColorImmediate"
                       @click="schedule = null">
                    Sofort
                </v-btn>
                <date-time-picker :color="btnColorSchedule"
                                  @change="schedule = $event; $emit('change', $event)"
                                  :date-time="dateTime"
                                  future-only/>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import DateTimePicker from "../../DateTimePicker";

export default {
    name: "NotificationSchedule",
    components: {DateTimePicker},
    props: {
        dateTime: {
            default: undefined
        }
    },
    data() {
        return {
            schedule: null
        }
    },
    computed: {
        btnColorImmediate() {
            return this.schedule === null ? 'primary lighten-1' : '';
        },
        btnColorSchedule() {
            return this.schedule === null ? '' : 'primary lighten-1';
        }
    },
    methods: {}
}
</script>

<style scoped>

</style>
